import React from 'react';
import {
  Box,
  Typography,
  Link,
} from '@mui/material';
import { FooterVersion } from './FooterVersion';
import { FeedbackForm } from './FeedbackForm';

export const Footer: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#B9B2A8', px: 4, py: 2, color: 'black' }}>
      {/* Top Flex Container */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
        }}
      >
        {/* Left Section */}
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flex: 1,
        }}>
          <FeedbackForm />
        </Box>
        <Box sx={{ flex: 1 }} />
        {/* Right Section */}
        <Box sx={{
          flex: 1,
          maxWidth: 600,
          marginRight: 20,
          flexDirection: 'column',
          display: 'flex',
          justifyContent: 'space-between',
          textAlign: 'right'
        }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Legal
          </Typography>
          <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', textAlign: 'right' }}>
            <Link href="#" underline="hover" sx={{ display: 'block', mb: 1, color: 'black' }}>
              Privacy Policy
            </Link>
            <Link href="#" underline="hover" sx={{ display: 'block', mb: 1, color: 'black' }}>
              Accessibility Statement
            </Link>
            <Link href="#" underline="hover" sx={{ display: 'block', mb: 1, color: 'black' }}>
              Terms & Conditions
            </Link>
            <Link href="#" underline="hover" sx={{ display: 'block', color: 'black' }}>
              Refund Policy
            </Link>
          </Box>
        </Box>
      </Box>
      <FooterVersion />
    </Box>
  );
};
